// import localStorage from "@react-native-async-storage/async-storage";

const setValue = async (key, value) => {
  await localStorage.setItem(key, value);
};

const getValue = async (value) => {
  const val = await localStorage.getItem(value);
  return val;
};

const deleteValue = async (value) => {
  await localStorage.removeItem(value);
};

const deleteMultipleValue = async (value) => {
  await localStorage.multiRemove(value);
};

const clearValue = async () => {
  await localStorage.clear();
};

export { setValue, getValue, deleteValue, clearValue, deleteMultipleValue };
